module.exports = __webpack_public_path__ + "static/media/block-2-item-5.f29aad89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-5.jpg
// module id = 1255
// module chunks = 270